
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 209 110"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#bf0a30","d":"M0 0h209v110H0z"}}),_c('path',{attrs:{"d":"M0 15h209M0 35h209M0 55h209M0 75h209M0 95h209","stroke":"#fff","stroke-width":"10"}}),_c('path',{attrs:{"fill":"#002868","d":"M0 0h50v50H0z"}}),_c('g',{attrs:{"transform":"matrix(15 0 0 15 25 25)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","fill":"#fff","transform":"rotate(18 3.157 -.5)","d":"M0 0v1h.5z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-144)"}})])])
          )
        }
      }
    